<script setup lang="ts">
// Outline map pin. Colour follows CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M11.6667 5.83333C11.6667 8.74592 8.43558 11.7792 7.35058 12.7161C7.24951 12.7921 7.12647 12.8332 7 12.8332C6.87353 12.8332 6.75049 12.7921 6.64942 12.7161C5.56442 11.7792 2.33333 8.74592 2.33333 5.83333C2.33333 4.59566 2.825 3.40867 3.70017 2.5335C4.57534 1.65833 5.76232 1.16667 7 1.16667C8.23768 1.16667 9.42466 1.65833 10.2998 2.5335C11.175 3.40867 11.6667 4.59566 11.6667 5.83333Z"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
    <path
      d="M8.75 5.83333C8.75 6.79983 7.9665 7.58333 7 7.58333C6.0335 7.58333 5.25 6.79983 5.25 5.83333C5.25 4.86684 6.0335 4.08333 7 4.08333C7.9665 4.08333 8.75 4.86684 8.75 5.83333Z"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
  </svg>
</template>
